import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FormManagerService } from '@sim/form';
import { BaseFiltersComponent, FilterFieldsOptions } from '@ui/ui.module';
import { CollectionItem, CollectionItemFilter, CollectionItemFilterMeta } from '../../models/collection';
import { iterableCollectionClassNameLabels } from '../../utils';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-collection-items-filters',
  styleUrls: ['./collection-items-filters.component.scss'],
  templateUrl: './collection-items-filters.component.html',
})
export class CollectionItemsFiltersComponent extends BaseFiltersComponent<CollectionItem, FilterFieldsOptions<CollectionItemFilter>> {

  readonly iterableCollectionClassNameLabels = iterableCollectionClassNameLabels;

  constructor(
    protected readonly formManager: FormManagerService,
  ) {
    super(formManager, CollectionItemFilterMeta);
  }

}
